import { FETCH_ALL_POSTS } from '../../constants/endpoints';
import request from '../request';

const getAllPosts = async ({ until, after, audience } = {}) => {
  const { data, status } = await request({
    method: 'get',
    url: FETCH_ALL_POSTS({ until, after, audience }),
  });
  if (status !== 200) throw new Error(`Posts fetch non 200: ${status}`);
  return data;
};

export default getAllPosts;
